import { render } from "./bokaOrder.vue?vue&type=template&id=1ce854e1"
import script from "./bokaOrder.vue?vue&type=script&lang=js"
export * from "./bokaOrder.vue?vue&type=script&lang=js"

import "./bokaOrder.vue?vue&type=style&index=0&id=1ce854e1&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__